import React from 'react';
import {observer} from "mobx-react";
import {CyClass} from "../../../../../common/cy-classes";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {InLobbySessionTimerLabelBox} from "./boxes/in-lobby-session-timer-label.box";
import {InLobbySessionTimerValueBox} from "./boxes/in-lobby-session-timer-value.box";
import {InLobbySessionTimerBox} from "./boxes/in-lobby-session-timer.box";
import {SessionTimerValueComponent} from "../session-timer-value.component";

export const InLobbySessionTimerComponent: React.FC<{className?: string}> = observer((props) => {
    const services = useServices();

    if(!services.sessionTimer.isEnabled) {
        return null;
    }

    const renderValue = (value: string) => {
        return (
            <InLobbySessionTimerValueBox className={CyClass('cy-session-timer')}>
                {value}
            </InLobbySessionTimerValueBox>
        )
    }


    return (
        <InLobbySessionTimerBox className={props.className}>
            {!services.device.os.isMobileOS &&
                <InLobbySessionTimerLabelBox>
                    {services.translation.translate('SESSION_TIMER_TITLE')}:
                </InLobbySessionTimerLabelBox>

            }
            <SessionTimerValueComponent renderValue={renderValue}/>

        </InLobbySessionTimerBox>
    )
})